<form
  [formGroup]="form"
  (ngSubmit)="openJob()"
  class="pt-0 pt-lg-4 pl-5 d-inline-block"
  *ngIf="isVendor"
  style="position: absolute; font-size: 16px; left: 0"
>
  <mat-form-field color="primary" style="width: 200px; z-index: 999">
    <mat-label>Job Number</mat-label>
    <input
      type="text"
      class="f{{ getMatchingJob() ? 'text-success' : '' }}"
      maxlength="7"
      placeholder="Search job number..."
      matInput
      [formControl]="jobSearchControl"
    />
    <span matSuffix>
      <i *ngIf="getMatchingJob()" class="flaticon-interface-5 text-success"></i>
      <i
        *ngIf="!jobSearchControl.value"
        class="flaticon-search-magnifier-interface-symbol"
      ></i>
      <i
        *ngIf="jobSearchControl.value && !getMatchingJob()"
        style="font-size: 16px; margin-right: 3px"
        class="la la-spinner spin"
      ></i>
    </span>
    <!-- <mat-autocomplete
      autoActiveFirstOption
      #auto="matAutocomplete"
      (optionSelected)="onJobSelect($event.option.value)"
    >
      <mat-option *ngFor="let job of filteredJobs | async" [value]="job">
        {{ getJobDisplay(job) }}
      </mat-option>
    </mat-autocomplete> -->
  </mat-form-field>
</form>
